import { dashboardApi } from '@/api';
import { ProjectDetailsDto } from '@/api/project/projectInfo';
import { queryOptions } from '@tanstack/react-query';

export type ProjectsListResponse = ProjectDetailsDto[];

const getProjectsList = async () => {
    return dashboardApi<ProjectsListResponse>({
        method: 'GET',
        url: '/front-office/project/list',
    });
};

export const getProjectsListQueryOptions = () =>
    queryOptions({
        queryKey: ['projects-list'],
        queryFn: () => getProjectsList(),
        staleTime: 5 * 60 * 1000,
    });
